import { render } from "./WaterFall.vue?vue&type=template&id=233b7667&scoped=true"
import script from "./WaterFall.vue?vue&type=script&lang=js"
export * from "./WaterFall.vue?vue&type=script&lang=js"

import "./WaterFall.vue?vue&type=style&index=0&id=233b7667&lang=less&scoped=true"

import exportComponent from "E:\\Workspace\\vue\\2023.03.13-掌阅瀑布流vue版\\zy-Client-Code\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233b7667"]])

export default __exports__